"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDown = _interopRequireDefault(require("./IconChevronDown"));
var IconChevronLeft = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDown.default).withConfig({
  displayName: "IconChevronLeft",
  componentId: "c11n-8-107-0__sc-ddr5cu-0"
})(["transform:rotate(90deg);"]);
var _default = IconChevronLeft;
exports.default = _default;